<div class="productDetailsGallery" [ngClass]="{'--active': active}">
  <div class="productDetailsGallery__container">
    <div #sliderRef class="productDetailsGallery__slider keen-slider">
      <picture  *ngFor="let picture of pictures" class="productDetailsGallery__slide keen-slider__slide">
        <img width="100%" height="" [ngSrc]="picture" [alt]="picture.title"/>
      </picture>
    </div>
    <div class="productDetailsGallery__name">{{title}}</div>
    <button class="productDetailsGallery__close flaticon-close" (click)="closeGallery()"></button>
    <button class="productDetailsGallery__left flaticon-down-arrow" (click)="slideNext()"></button>
    <button class="productDetailsGallery__right flaticon-down-arrow" (click)="slidePrev()"></button>
  </div>
</div>
